import React, { Component } from 'react';
import { Package, Gift, CheckCircle2, ShieldCheck, Zap, Lock, HeadphonesIcon, Star } from 'lucide-react';
import { Section, Button, OrganicDivider } from './ui';
import { CountdownTimer } from './ConversionComponents';
import { fireAddToCart } from './pixel';
export const Deliverables = () => {
  const items = [{
    title: 'Manual Completo de Preparaciones Medicinales',
    value: '$87',
    desc: 'Más de 970 recetas naturales organizadas paso a paso.',
    image: 'https://cdn.magicpatterns.com/uploads/jHowNpn3z4E9sx8A9cV5ZD/ChatGPT_Image_7_may_2026,_12_04_01_p.m.png',
    featured: true
  }, {
    title: 'Guía de Aceites Herbales',
    value: '$27',
    desc: 'Aprende preparaciones naturales para bienestar diario.',
    image: 'https://cdn.magicpatterns.com/uploads/hRWAju19eMqc16HF2Car42/ChatGPT_Image_7_may_2026,_12_54_41_p.m.png',
    featured: true
  }, {
    title: 'Recetario Detox Natural',
    value: '$19',
    desc: 'Bebidas y mezclas para revitalizar el cuerpo.',
    image: 'https://cdn.magicpatterns.com/uploads/mveg8ZaaFuzGB6RNYRgNNp/Gemini_Generated_Image_7kim5y7kim5y7kim.png',
    featured: true
  }];
  return <Section bg="beige" data-id="element-292">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-293">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-petroleum" data-id="element-294">
          Todo lo que recibes hoy:
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-6" data-id="element-295">
        {items.map((item, i) => <div key={i} className="relative group" data-id="element-296">
            {/* Subtle hover-only glow */}
            <div className={`absolute -inset-0.5 rounded-[26px] blur-sm transition-opacity duration-500 pointer-events-none ${item.featured ? 'bg-gradient-to-r from-herbal/50 via-herbal/40 to-herbal/50 opacity-0 group-hover:opacity-60' : 'bg-gradient-to-r from-herbal/30 via-gold/20 to-herbal/30 opacity-0 group-hover:opacity-40'}`} data-id="element-297"></div>

            {/* Card */}
            <div className={`relative bg-white rounded-[24px] flex flex-col sm:flex-row gap-6 items-start sm:items-center transition-all duration-300 group-hover:-translate-y-0.5 ${item.featured ? 'p-5 md:p-7 border-2 border-herbal/60 shadow-[0_8px_24px_-12px_rgba(39,174,96,0.25),inset_0_1px_0_rgba(255,255,255,0.9)] group-hover:border-herbal group-hover:shadow-[0_12px_30px_-10px_rgba(39,174,96,0.35)]' : 'p-6 md:p-8 border border-gray-100 shadow-sm group-hover:border-herbal/30'}`} data-id="element-298">
              {item.featured && item.image ? <div className="relative shrink-0 self-center" data-id="element-299">
                  <div className="relative w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden border border-gold/30 shadow-md" data-id="element-300">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-301" />
                  </div>
                </div> : <div className="bg-herbal/10 p-4 rounded-2xl text-herbal shrink-0" data-id="element-302">
                  <Package size={32} data-id="element-303" />
                </div>}

              <div className="flex-1" data-id="element-304">
                {item.featured && <span className="inline-block bg-gold/20 text-petroleum text-[10px] font-bold tracking-widest px-2 py-1 rounded-full mb-2" data-id="element-305">
                    ⭐ PRODUCTO PRINCIPAL
                  </span>}
                <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-2 gap-2" data-id="element-306">
                  <h3 className={`font-bold text-petroleum ${item.featured ? 'text-xl md:text-2xl' : 'text-xl'}`} data-id="element-307">
                    {item.title}
                  </h3>
                  <span className="text-gray-400 line-through font-medium shrink-0" data-id="element-308">
                    {item.value}
                  </span>
                </div>
                <p className="text-gray-600" data-id="element-309">{item.desc}</p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    title: 'Bono 1 — Huerto Medicinal en Casa',
    value: '$29',
    desc: 'Aprende a cultivar tus propias plantas medicinales fácilmente.'
  }, {
    title: 'Bono 2 — 10 Baños Energéticos Naturales',
    value: '$17',
    desc: 'Rituales naturales para relajación y bienestar emocional.'
  }, {
    title: 'Bono 3 — Desafío Natural de 7 Días',
    value: '$37',
    desc: 'Pequeños hábitos diarios para sentir más energía y equilibrio.'
  }];
  return <Section bg="dark" className="relative overflow-hidden" data-id="element-310">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-311"></div>

      <div className="text-center max-w-3xl mx-auto mb-12 relative z-10" data-id="element-312">
        <div className="inline-flex items-center gap-2 bg-urgency text-white px-6 py-2 rounded-full font-bold animate-pulse-slow mb-8 shadow-[0_0_15px_rgba(192,57,43,0.5)]" data-id="element-313">
          <Zap size={18} data-id="element-314" />⚡ DISPONIBLE SOLO HOY
        </div>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-gold mb-4" data-id="element-315">
          Regalos Exclusivos
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-6 relative z-10" data-id="element-316">
        {bonuses.map((bonus, i) => <div key={i} className="bg-white/10 backdrop-blur-md p-6 md:p-8 rounded-[24px] border border-gold/30 flex flex-col sm:flex-row gap-6 items-start sm:items-center" data-id="element-317">
            <div className="bg-gold/20 p-4 rounded-2xl text-gold shrink-0" data-id="element-318">
              <Gift size={32} data-id="element-319" />
            </div>
            <div className="flex-1" data-id="element-320">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-2 gap-2" data-id="element-321">
                <h3 className="text-xl font-bold text-white" data-id="element-322">{bonus.title}</h3>
                <div className="flex items-center gap-2" data-id="element-323">
                  <span className="text-gray-400 line-through text-sm" data-id="element-324">
                    {bonus.value}
                  </span>
                  <span className="bg-gold text-petroleum text-xs font-bold px-2 py-1 rounded" data-id="element-325">
                    GRATIS
                  </span>
                </div>
              </div>
              <p className="text-gray-300" data-id="element-326">{bonus.desc}</p>
            </div>
          </div>)}

        <div className="mt-8 text-center bg-urgency/20 border border-urgency/50 p-4 rounded-xl text-white flex items-center justify-center gap-2" data-id="element-327">
          <span className="text-xl" data-id="element-328">⚠️</span>
          <p className="font-medium" data-id="element-329">
            Esta colección completa de bonos desaparece cuando cierres esta
            página.
          </p>
        </div>
      </div>
    </Section>;
};
export const OfferSummary = () => {
  return <Section bg="cream" className="overflow-visible" data-id="element-330">
      <div className="max-w-2xl mx-auto perspective-[1200px]" data-id="element-331">
        {/* Subtle hover-only glow */}
        <div className="relative group" data-id="element-332">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-herbal/40 via-herbal/30 to-herbal/40 rounded-[36px] blur-sm opacity-0 group-hover:opacity-60 transition-opacity duration-500 pointer-events-none" data-id="element-333"></div>

          {/* Main 3D card */}
          <div className="relative bg-white rounded-[32px] p-8 md:p-12 overflow-hidden border-2 border-herbal/50 transition-all duration-500 hover:-translate-y-1 hover:border-herbal/80" style={{
          boxShadow: '0 12px 28px -10px rgba(39, 174, 96, 0.2), 0 6px 14px -6px rgba(15, 61, 62, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.9)'
        }} data-id="element-334">
            {/* Subtle inner highlight */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-herbal/10 blur-3xl rounded-full pointer-events-none" data-id="element-335"></div>

            {/* Top corner ribbon */}
            <div className="absolute -top-1 -right-1 bg-gradient-to-br from-gold to-yellow-600 text-petroleum font-bold text-xs px-4 py-2 rounded-bl-2xl rounded-tr-[32px] shadow-lg z-10" data-id="element-336">
              ✨ TODO INCLUIDO
            </div>

            <h2 className="text-2xl md:text-3xl font-heading font-bold text-center text-petroleum mb-2 relative z-10" data-id="element-337">
              Resumen de tu pedido hoy:
            </h2>
            <p className="text-center text-sm text-gray-500 mb-8 relative z-10 italic" data-id="element-338">
              Esto es lo que vas a recibir al confirmar tu acceso
            </p>

            <div className="space-y-3 mb-8 relative z-10" data-id="element-339">
              {[{
              text: 'Manual Completo de Preparaciones Medicinales',
              type: 'main'
            }, {
              text: 'Guía de Aceites Herbales',
              type: 'main'
            }, {
              text: 'Recetario Detox Natural',
              type: 'main'
            }, {
              text: 'Huerto Medicinal en Casa',
              type: 'bonus'
            }, {
              text: '10 Baños Energéticos Naturales',
              type: 'bonus'
            }, {
              text: 'Desafío Natural 7 Días',
              type: 'bonus'
            }].map((item, i) => <div key={i} className={`flex items-center gap-3 p-3 rounded-xl ${item.type === 'main' ? 'bg-herbal/5 border border-herbal/20' : 'bg-gold/5 border border-gold/20'}`} data-id="element-340">
                  {item.type === 'main' ? <CheckCircle2 className="text-herbal shrink-0" size={20} data-id="element-341" /> : <Gift className="text-gold shrink-0" size={20} data-id="element-342" />}
                  <span className={item.type === 'main' ? 'font-medium text-gray-800' : 'font-medium text-gray-700'} data-id="element-343">
                    {item.text}
                  </span>
                  {item.type === 'bonus' && <span className="ml-auto text-xs font-bold text-gold bg-gold/10 px-2 py-0.5 rounded-full shrink-0" data-id="element-344">
                      GRATIS
                    </span>}
                </div>)}
            </div>

            <div className="flex items-center justify-center gap-6 mb-6 text-sm font-medium text-gray-600 bg-beige/50 p-3 rounded-xl border border-gold/20" data-id="element-345">
              <div className="flex items-center gap-1.5" data-id="element-346">
                <ShieldCheck size={16} className="text-herbalDark" data-id="element-347" /> Garantía
                de 7 días
              </div>
              <div className="flex items-center gap-1.5" data-id="element-348">
                <Zap size={16} className="text-gold" data-id="element-349" /> Acceso inmediato
              </div>
            </div>

            <div className="text-center border-t-2 border-dashed border-herbal/20 pt-6 relative z-10" data-id="element-350">
              <p className="text-gray-500 mb-2 text-sm" data-id="element-351">
                Valor total:{' '}
                <span className="line-through font-medium" data-id="element-352">$87 USD</span>
              </p>
              <p className="text-xs font-bold text-urgency tracking-widest mb-2" data-id="element-353">
                HOY SOLO PAGAS:
              </p>
              <div className="text-5xl md:text-6xl font-heading font-bold text-petroleum mb-3" data-id="element-354">
                $6,36 <span className="text-xl text-gray-400" data-id="element-355">USD</span>
              </div>
              <div className="inline-block bg-gradient-to-r from-[#27AE60] to-[#1E8449] text-white font-bold px-5 py-2 rounded-full text-sm shadow-md" data-id="element-356">
                🎉 AHORRAS 93% — Solo hoy
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
};
export const Checkout = () => {
  return <>
      <OrganicDivider type="wave" color="fill-cream" data-id="element-357" />
      <Section id="checkout" bg="beige" className="pt-8 pb-24" data-id="element-358">
        <div className="max-w-4xl mx-auto" data-id="element-359">
          {/* Live activity trigger */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-6 text-sm" data-id="element-360">
            <div className="inline-flex items-center gap-2 bg-white px-3 py-1.5 rounded-full border border-gray-200 shadow-sm" data-id="element-361">
              <span className="relative flex h-2 w-2" data-id="element-362">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-herbal opacity-75" data-id="element-363"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-herbal" data-id="element-364"></span>
              </span>
              <span className="font-medium text-gray-700" data-id="element-365">
                <span className="font-bold text-petroleum" data-id="element-366">1.247 personas</span>{' '}
                viendo esta página ahora
              </span>
            </div>
          </div>

          {/* Social proof */}
          <div className="text-center mb-4" data-id="element-367">
            <div className="inline-flex items-center gap-2 mb-2" data-id="element-368">
              <div className="flex text-yellow-500" data-id="element-369">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-370" />)}
              </div>
              <span className="font-bold text-petroleum" data-id="element-371">4.9/5</span>
              <span className="text-gray-500 text-sm" data-id="element-372">
                — +27.000 personas satisfechas
              </span>
            </div>
          </div>

          {/* Headline */}
          <div className="text-center mb-8" data-id="element-373">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-petroleum leading-tight" data-id="element-374">
              Accede hoy y comienza tu{' '}
              <span className="italic text-herbalDark" data-id="element-375">
                transformación natural
              </span>
            </h2>
          </div>

          {/* The offer card — image + CTA unified */}
          <div className="bg-white rounded-[32px] shadow-2xl border-2 border-gold/40 overflow-hidden relative" data-id="element-376">
            {/* Top urgency banner */}
            <div className="bg-gradient-to-r from-urgency via-red-600 to-urgency text-white text-center py-3 px-4 font-bold text-sm md:text-base flex items-center justify-center gap-2" data-id="element-377">
              <span className="relative flex h-2.5 w-2.5" data-id="element-378">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-379"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" data-id="element-380"></span>
              </span>
              🔥 PRECIO DE LANZAMIENTO · SOLO POR HOY · 93% DE DESCUENTO
            </div>

            {/* Offer image */}
            <div className="relative" data-id="element-381">
              <img src="https://cdn.magicpatterns.com/uploads/hCNizZnckf9c467zgq6MGq/Oferta_Ppal.png" alt="970+ Recetas Naturales + 6 Bonos Premium" className="w-full h-auto object-cover" data-id="element-382" />
            </div>

            {/* Body */}
            <div className="p-6 md:p-10" data-id="element-383">
              {/* Timer */}
              <div className="bg-gradient-to-br from-petroleum to-[#0A2A2B] rounded-2xl p-6 md:p-8 mb-8 relative overflow-hidden" data-id="element-384">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,168,76,0.15),transparent_70%)]" data-id="element-385"></div>
                <div className="relative z-10 text-center" data-id="element-386">
                  <div className="inline-flex items-center gap-2 bg-urgency/20 text-gold px-3 py-1 rounded-full text-xs font-bold mb-4 border border-gold/30" data-id="element-387">
                    <Zap size={14} data-id="element-388" />
                    LA OFERTA EXPIRA EN
                  </div>
                  <CountdownTimer variant="dark" data-id="element-389" />
                  <p className="text-gold/80 text-xs md:text-sm mt-4 italic" data-id="element-390">
                    ⚠️ Después de este tiempo el precio vuelve a $87 USD
                  </p>
                </div>
              </div>

              {/* Quick value reminder — no price, focus on what they get */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8" data-id="element-391">
                {[{
                icon: '📚',
                label: '970+ Recetas'
              }, {
                icon: '🎁',
                label: '6 Bonos GRATIS'
              }, {
                icon: '⏱️',
                label: 'Acceso de por vida'
              }, {
                icon: '💚',
                label: 'Garantía 7 días'
              }].map((item, i) => <div key={i} className="bg-beige/50 rounded-xl p-3 text-center border border-gold/10" data-id="element-392">
                    <div className="text-2xl mb-1" data-id="element-393">{item.icon}</div>
                    <p className="text-xs md:text-sm font-bold text-petroleum" data-id="element-394">
                      {item.label}
                    </p>
                  </div>)}
              </div>

              {/* Main CTA */}
              <a href="https://rutinaspracticas.com/cart/53026745483586:1" onClick={() => fireAddToCart()} className="block w-full bg-gradient-to-r from-[#27AE60] to-[#1E8449] hover:from-[#1E8449] hover:to-[#27AE60] text-white text-xl md:text-3xl font-bold py-5 md:py-6 px-6 rounded-full shadow-[0_10px_30px_rgba(39,174,96,0.4)] hover:shadow-[0_15px_40px_rgba(201,168,76,0.5)] transition-all duration-300 transform hover:scale-[1.02] text-center mb-4 relative overflow-hidden group" data-id="element-395">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-396">
                  ✨ QUIERO MI ACCESO INMEDIATO
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-397"></div>
              </a>

              {/* Subtle CTA reinforcement */}
              <p className="text-center text-sm text-gray-500 italic mb-6" data-id="element-398">
                👇 Haz clic arriba y recibe acceso en menos de 30 segundos
              </p>

              {/* Trust badges */}
              <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm font-medium text-gray-600 pt-4 border-t border-gray-100" data-id="element-399">
                <div className="flex items-center gap-1.5" data-id="element-400">
                  <Lock size={16} className="text-herbal" data-id="element-401" /> Pago 100% seguro
                </div>
                <div className="flex items-center gap-1.5" data-id="element-402">
                  <Zap size={16} className="text-gold" data-id="element-403" /> Acceso inmediato
                </div>
                <div className="flex items-center gap-1.5" data-id="element-404">
                  <ShieldCheck size={16} className="text-herbalDark" data-id="element-405" /> Garantía
                  7 días
                </div>
              </div>
            </div>
          </div>

          {/* Risk reversal block */}
          <div className="mt-8 bg-white rounded-[24px] p-6 md:p-8 border-2 border-herbal/30 shadow-md flex flex-col md:flex-row items-center gap-6" data-id="element-406">
            <div className="shrink-0 w-20 h-20 rounded-full bg-herbal/10 flex items-center justify-center border-4 border-herbal/30" data-id="element-407">
              <ShieldCheck className="text-herbalDark" size={40} data-id="element-408" />
            </div>
            <div className="text-center md:text-left" data-id="element-409">
              <p className="font-heading font-bold text-petroleum text-xl mb-1" data-id="element-410">
                Garantía blindada de 7 días — sin riesgo
              </p>
              <p className="text-gray-600 text-sm md:text-base" data-id="element-411">
                Si no quedas 100% satisfecha, te devolvemos cada centavo. Sin
                preguntas, sin trámites.
                <span className="font-bold text-petroleum" data-id="element-412">
                  {' '}
                  Tú no arriesgas nada.
                </span>
              </p>
            </div>
          </div>

          {/* Final scarcity */}
          <p className="text-center mt-6 text-sm text-gray-500 italic" data-id="element-413">
            ⚠️ Esta oferta es por tiempo limitado. Una vez expirada, el precio
            regresa a $87 USD.
          </p>
        </div>
      </Section>
    </>;
};
export const MicroTrust = () => {
  return <div className="bg-petroleum text-gray-300 py-6 border-b border-white/10" data-id="element-414">
      <div className="max-w-[1200px] mx-auto px-4 flex flex-wrap justify-center gap-6 md:gap-12 text-sm" data-id="element-415">
        <div className="flex items-center gap-2" data-id="element-416">
          <Lock size={18} className="text-gold" data-id="element-417" /> SSL Seguro 256 bits
        </div>
        <div className="flex items-center gap-2" data-id="element-418">
          <Zap size={18} className="text-gold" data-id="element-419" /> Acceso inmediato
        </div>
        <div className="flex items-center gap-2" data-id="element-420">
          <ShieldCheck size={18} className="text-gold" data-id="element-421" /> Garantía de 7 días
        </div>
        <div className="flex items-center gap-2" data-id="element-422">
          <HeadphonesIcon size={18} className="text-gold" data-id="element-423" /> Soporte real
        </div>
      </div>
    </div>;
};